import React, { useState, useEffect } from 'react';
import "../css/Countdown.css";

const CountdownTimer = ({ targetTime, targetTime_pa, setlang }) => {
  // State to store user input time and current countdown
  const [timeLeft, setTimeLeft] = useState(null);
  const [daysLeft, setdayLeft] = useState(null);
  const [hoursLeft, setHrLeft] = useState(null);
  const [minutesLeft, setMinLeft] = useState(null);
  const [secondsLeft, setSecLeft] = useState(null);

  const toPersiDigits = (str) =>
    str.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

  // Function to calculate the remaining time
  const calculateTimeLeft = () => {
    if (!targetTime) return;

    const currentTime = new Date();
    const targetDate = new Date(targetTime);
    const difference = targetDate - currentTime;

    if (difference <= 0) {
      setTimeLeft(setlang==="en"?'Time is up!':'مزایده به پایان رسید');
    } else {
      const days = Math.floor(difference / (1000 * 60 * 60 * 24))
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60 ));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      setdayLeft(days);
      setHrLeft(hours);
      setMinLeft(minutes);
      setSecLeft(seconds);
    }
  };

  // Update countdown every second
  useEffect(() => {
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer); // Clean up the interval on unmount
  }, [targetTime]); // Dependency on targetTime

  return (
    <>
    <div className={setlang === "en" ? 'countdown': 'countdown-fa' }>
      {setlang === "en" ?
      <div className='countdown-deadline'> <p style={{fontWeight:'Bold'}}>Bidding Deadline: </p> <p> {new Date(targetTime_pa).toLocaleString()} </p> </div>
      :
      <>
        <div className='countdown-deadline-fa'> <p style={{fontWeight:'Bold'}}>  تاریخ پایان مزایده:  </p> <p style={{direction:"ltr"}}> {toPersiDigits((targetTime_pa))} </p> </div>
      </>
      }
      <div className={setlang === "en" ? 'countdown-cont' : 'countdown-cont-fa' }>
        <span style={{alignContent:'center'}}>{setlang==="en"? "Time Left" : " زمان باقی مانده"}</span> 
        {setlang === "en" ? (
        <table className='countdown-table'>
          <tr>
            <th>D</th>
            <th>H</th>
            <th>M</th>
            <th>S</th>
          </tr>
          <tr>
            <td>{daysLeft}</td>
            <td>{hoursLeft}</td>
            <td>{minutesLeft}</td>
            <td>{secondsLeft}</td>
          </tr>
        </table>
        ):(
        <table className='countdown-table-fa'>
          <tr>
            <th>ثانیه</th>
            <th>دقیقه</th>
            <th>ساعت</th>
            <th>روز</th>
          </tr>
          <tr>
            <td>{(secondsLeft)}</td>
            <td>{(minutesLeft)}</td>
            <td>{(hoursLeft)}</td>
            <td>{(daysLeft)}</td>
          </tr>
        </table>
        )}

        {/*
          <div>
          {timeLeft === null ? '...' : timeLeft}
        </div>
        */}
      
      </div>
    </div>
    </>
  );
};

export default CountdownTimer;